import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.7",
  height: "10.35",
  fill: "none",
  viewBox: "177.226 1176.8 5.7 10.35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "fills" }, [
      _createElementVNode("path", {
        d: "M182.776 1183.9c.2.2.2.6 0 .8l-2.3 2.3c-.2.2-.6.2-.8 0l-2.3-2.3c-.2-.2-.2-.6 0-.8s.6-.2.8 0l1.3 1.3v-7.8c0-.3.3-.6.6-.6s.6.3.6.6v7.8l1.3-1.3c.2-.2.6-.2.8 0",
        class: "st2"
      })
    ], -1)
  ]))]))
}
export default { render: render }